'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModulesSidebar = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { changeItem: _modules.changeItem }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ModulesSidebar, _Component);

  function ModulesSidebar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModulesSidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModulesSidebar.__proto__ || (0, _getPrototypeOf2.default)(ModulesSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      types: {
        core: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleOnClick = function (module, modtype, item, event) {
      _this.props.changeItem(module, modtype, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(ModulesSidebar, [{
    key: 'renderListGroup',


    /*
     * Render a list group, list groups are app, extra, activity
     * These are clickable tabs on the sidebar
     */
    value: function renderListGroup(title, type, typeID) {
      var _this2 = this;

      var styles = require('./Modules.scss');
      var modObjs = {
        'module1': [this.props.moduleData['module0']['app1'], this.props.moduleData['module0']['app2'], this.props.moduleData['module0']['app3'], this.props.moduleData['module0']['app4'], this.props.moduleData['module0']['app5'], this.props.moduleData['module1']['app1'], this.props.moduleData['module1']['app2'], this.props.moduleData['module1']['app5'], this.props.moduleData['module1']['app6'], this.props.moduleData['module1']['app8'], this.props.moduleData['module1']['app9'], this.props.moduleData['module1']['app10']],
        'module2': [this.props.moduleData['module2']['app1'], this.props.moduleData['module2']['app2'], this.props.moduleData['module2']['app3'], this.props.moduleData['module2']['app4'], this.props.moduleData['module2']['app5'], this.props.moduleData['module2']['app6'], this.props.moduleData['module2']['app7'], this.props.moduleData['module2']['app8'], this.props.moduleData['module2']['app9']],
        'module3': [this.props.moduleData['module3']['app1'], this.props.moduleData['module3']['app2'], this.props.moduleData['module3']['app3'], this.props.moduleData['module3']['app4'], this.props.moduleData['module3']['app5'], this.props.moduleData['module3']['app6'], this.props.moduleData['module3']['app7'], this.props.moduleData['module4']['app3'], this.props.moduleData['module4']['app7'], this.props.moduleData['module3']['app8']]

      };
      // const modObj = this.props.moduleData['module' + this.props.module];
      var modObj = modObjs['module' + this.props.module];
      console.log('moduleData', this.props.moduleData);
      console.log('module', this.props.module);
      console.log('modObj', modObj);
      return _react2.default.createElement(
        'div',
        null,
        type.length > 0 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            title
          ),
          _react2.default.createElement(
            ReactBootstrap.ListGroup,
            null,
            type.map(function (item, index) {
              return _react2.default.createElement(
                ReactBootstrap.ListGroupItem,
                { className: styles.borderless,
                  onClick: _this2.handleOnClick.bind(_this2, _this2.props.module, typeID, item.id),
                  active: _this2.props.modtype === typeID && _this2.props.item === item.id, key: title + '' + item.id },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 2, sm: 2, xs: 2 },
                    index + 1 + ')'
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 10, sm: 10, xs: 10 },
                    item.title,
                    typeID === 0 && modObj[index] && modObj[index].isCompleted && _react2.default.createElement('i', { className: 'fa fa-check pull-right ' + styles.orangeText })
                  )
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Modules.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 2, sm: 3, xs: 2, lg: 2, className: styles.sidebar },
          this.renderListGroup('Core Info', this.props.core, this.state.types.core),
          this.renderListGroup('Extra Info', this.props.extra, this.state.types.extra),
          this.renderListGroup('Activities', this.props.activities, this.state.types.activity)
        )
      );
    }
  }]);
  return ModulesSidebar;
}(_react.Component), _class2.propTypes = {
  core: _propTypes2.default.array,
  extra: _propTypes2.default.array,
  activities: _propTypes2.default.array,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired,
  moduleData: _propTypes2.default.object
}, _temp2)) || _class);
/* eslint-enable */

exports.default = ModulesSidebar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/ModulesSidebar.js
// module id = 1218
// module chunks = 0